const SelectedService = ({ serviceType = 'maintenance' }) => {
  return (
    <div className="selected-service">
      <span>{serviceType}</span>
    </div>
  )
}

export default SelectedService
